import { STYLE } from '../../../config/constraits';
import { Card } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { addFilter, saveBeforeFilter } from '../../../redux/filtersSlice';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { convertDateToUnixWithTime } from '../../../utils/dateUtils';
import { useTranslation } from 'react-i18next';
import { useRef } from 'react';
import ChartShareActions from '../../../components/ChartShareActions';
import { RootState } from '../../../redux/store';
import { SelectedFilter } from '../../../components/Filters/types';

export type AverageNpsByData = {
    campData: number;
    feelingsAverage: number;
    feelings15DayAverage: number
};

interface FeelingChartProps {
    data: AverageNpsByData[];
}

export default function FeelingChart({ data }: FeelingChartProps) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { t } = useTranslation();

    const feelingchartRef = useRef<HTMLDivElement>(null);

    // Preparar datos en el formato que acepta recharts
    const chartData = data.map((item) => ({
        name: new Date(item.campData).toLocaleDateString(),
        Feelings: item.feelingsAverage.toFixed(2) || 0,
        Feelings15: item.feelings15DayAverage.toFixed(2) || 0,
    }));

    const handleChartClick = (e: any) => {
        const activePoint = e.activePayload && e.activePayload[0] ? e.activePayload[0].payload : null;
        if (activePoint) {
            const selectedData = activePoint.name;
            if (selectedData) {
                const initialDateTimeStamp = convertDateToUnixWithTime(selectedData, '00:00');
                const finalDateTimeStamp = convertDateToUnixWithTime(selectedData, '23:59');
                if (finalDateTimeStamp && initialDateTimeStamp) {
                    const filter: SelectedFilter = {
                        name: 'AnswerDate',
                        dateValues: {
                            initialDate: initialDateTimeStamp,
                            finalDate: finalDateTimeStamp,
                        }
                    };
                    dispatch(saveBeforeFilter('dashboard'));

                    dispatch(addFilter({ table: 'dashboard', filter: filter }));
                    navigate('/survey-patient/historic');
                }
            }
        }
    };

    const selectedFilters = useSelector((state: RootState) => state.filters.dashboard.selectedFilters);

    return (
        <>            
            <div ref={feelingchartRef}>
                <Card
                    style={{
                        backgroundColor: "#F5F5F5",
                        border: "none",
                        borderRadius: STYLE.BORDER_RADIUS,
                    }}
                    className="p-3"
                >
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <h4>{t("dashboard:dashboardDistributionTime")}</h4>
                        <div className="d-flex align-items-center">
                            <ChartShareActions
                                chartRef={feelingchartRef}
                                title={t("dashboard:dashboardDistributionTime")}
                                filters={selectedFilters}
                                t={t}
                            />
                        </div>
                    </div>
                    <ResponsiveContainer width="100%" height={300} >
                        <LineChart data={chartData} onClick={handleChartClick}>
                            <CartesianGrid strokeDasharray="3 3" vertical={false} />
                            <XAxis dataKey="name" />
                            <YAxis type="number" domain={[0, 5]} />
                            <Tooltip />
                            <Legend verticalAlign="top" height={36} />
                            <Line
                                type="monotone"
                                dataKey="Feelings"
                                name={t("dashboard:dashboardDistributionTimeComment1")}
                                stroke="green"
                                dot={{ r: 0 }}
                            />
                            <Line
                                type="monotone"
                                dataKey="Feelings15"
                                name={t("dashboard:dashboardDistributionTimeComment2")}
                                stroke="purple"
                                dot={{ r: 0 }}
                            />
                        </LineChart>
                    </ResponsiveContainer>
                </Card>
            </div>
        </>
    );
}
